export enum PackageStatus {
    INSTALLED = "INSTALLED",
    NOT_INSTALLED = "NOT_INSTALLED",
    ERROR = "ERROR",
}

export interface PackageStatusResponse {
    name: string;
    status: PackageStatus;
}
